<!-- /src/views/UserLogin.vue -->
<template>
  <div class="page page--login">
    <div class="page__wrap"></div>
    <Logo class="logo" />
    <form
      class="form"
      :class="{ 'form--animationActive': loggingIn === true }"
      @submit.prevent="loginUser"
    >
      <BaseInput
        label="Username"
        v-model="credentials.username"
        type="text"
      />

      <!-- START: Password field with toggle -->
      <div class="password-input-wrapper">
        <BaseInput
          label="Password"
          v-model="credentials.password"
          :type="passwordFieldType"
          class="input-has-toggle"
        />
        <button
          type="button"
          class="password-toggle"
          @click="togglePasswordVisibility"
          :aria-label="showPassword ? 'Hide password' : 'Show password'"
        >
          <!-- FontAwesome icons for show/hide functionality -->
          <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          <!-- Visually hidden text for screen readers -->
          <span class="sr-only">{{ showPassword ? 'Hide password' : 'Show password' }}</span>
        </button>
      </div>
      <!-- END: Password field with toggle -->

      <div class="button__group">
        <a href="/wp-login.php?action=lostpassword" class="forgot-password"
          >Forgot Password?</a
        >
        <input
          type="submit"
          value="Login"
          class="button button--brandPrimary"
        />
      </div>
    </form>
  </div>
</template>

<script>
import Logo from '@/components/common/Header/_HeaderLogo'
import { checkNested } from '@/components/common/utils/helpers'
// Assuming BaseInput is imported here, though not explicitly shown in your snippet
// import BaseInput from '@/components/BaseInput.vue'; // <-- Make sure BaseInput is imported!

export default {
  data() {
    return {
      loggingIn: false,
      showPassword: false, // New data property to control password visibility
      credentials: {
        username: '',
        password: '',
        rememberMe: true,
      },
    }
  },
  computed: {
    userGroups() {
      return this.$store.dispatch['user/getUserGroups']
    },
    // Computed property to dynamically set the input type
    passwordFieldType() {
      return this.showPassword ? 'text' : 'password';
    }
  },

  methods: {
    loginUser() {
      let loginAttempt = this.$store
        .dispatch('user/login', {
          username: this.credentials.username,
          password: this.credentials.password,
        })
        .then(res => {
          if (res) {
            this.$store.dispatch('user/requestUserData').then(res => {
              this.loggingIn = true
              if (checkNested(res, ['acf'])) {
                if (
                  typeof this.$route.query != 'undefined' &&
                  typeof this.$route.query.loginRedirect != 'undefined'
                ) {
                  this.$router.push({
                    path: this.$route.query.loginRedirect,
                  })
                } else {
                  this.$router.push({ name: 'dashboard' })
                }
              }
            })
          }
        })
    },
    getUserGroups() {
      console.log(this.$store.dispatch['user/getUserGroups'])
      return this.$store.dispatch['user/getUserGroups']
    },
    // New method to toggle password visibility
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
  },

  mounted() {
    this.$store.dispatch('updatePageTitle', 'Sign In')
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('updateHeaderRev', true)
      vm.$store.dispatch('updatePageClasses', 'no-branding-header')
    })
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('updatePageClasses', '')
    next()
  },

  components: {
    Logo,
    // BaseInput, // <-- Don't forget to list BaseInput here if it's not already
  },
}
</script>
<style scoped>

.page--login {
  background-image: url(../assets/img/carr_front_desk.jpg);
  background-size: cover;
  background-position: center center;
  /* height: 100vh; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  /* perspective: 600px; */

  .logo {
    width: 300px;
    margin-bottom: 2rem;
    position: relative;
  }

  .page__wrap {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(5, 5, 5, 0.5);
  }

  .form {
    display: block;
    background-color: white;
    padding: 2rem;
    min-width: 350px;
    box-shadow: 0 0 2rem rgba(0, 0, 0, 0.5);
    position: relative;
    transition: transform 0.5s ease, opacity 0.5s ease;
    will-change: transform, opacity;

    &__control {
      margin-bottom: 1.5rem;
    }

    &--animationActive {
      transform: scale(1.2);
      opacity: 0;
    }
  }

  .forgot-password {
    font-size: 70%;
    color: inherit;

    &:hover {
      text-decoration: underline;
    }
  }

  .button__group {
    display: grid;
    grid-template-columns: auto auto;
    justify-items: end;
  }
}

/* NEW STYLES FOR PASSWORD TOGGLE */

.password-input-wrapper {
  position: relative;
  /* This wrapper takes the margin-bottom that BaseInput's root element (.form__control) would normally have. */
  margin-bottom: 1.5rem;
}

.password-toggle {
  position: absolute;
  right: 10px; /* Distance from the right edge of the input field */
  /* Vertically center the button within the visual area of the input field.
     This `top` value might need slight adjustment based on BaseInput's internal structure
     (e.g., if the label is very tall and pushes the input down significantly).
     The `transform: translateY(-50%)` centers it precisely based on its own height. */
  top: calc(50% + 10px); /* Adjust '10px' to shift vertically if needed based on label height */
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0; /* Remove default button padding */
  color: #666; /* Default icon color */
  font-size: 1.1em; /* Adjust icon size as needed */
  z-index: 10; /* Ensure the toggle button is above the input field */
  display: flex; /* Helps with icon alignment */
  align-items: center;
  justify-content: center;
}

.password-toggle:hover {
  color: #333; /* Darker color on hover */
}

/* Visually hide text for screen readers (used with aria-label) */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

/* IMPORTANT: Styling the input itself to make space for the toggle */
/* This rule attempts to target the actual <input> element rendered *inside* BaseInput.
   The `>>>` or `:deep()` combinator (Vue's deep selector) is used to pierce into
   the scoped styles of `BaseInput` and apply padding to its internal input element.
   This is crucial to prevent the password text from overlapping the toggle icon. */
.password-input-wrapper :deep(input[type="password"]),
.password-input-wrapper :deep(input[type="text"]) {
    padding-right: 40px; /* Adjust this value to ensure enough space for the icon */
}

/* If the deep selector doesn't work for some reason (e.g., specific build setup),
   and if BaseInput takes a `class` prop that gets applied to its *root* element (which is likely the case),
   you could try to globally target inputs within elements that have the `input-has-toggle` class,
   or modify `BaseInput` itself to add the padding.
   E.g., if BaseInput applies `.form__control` to its root div and that contains the input:
   .password-input-wrapper .form__control input { padding-right: 40px; }
   But the `:deep()` selector is generally preferred for this scenario. */
</style>